import { useState, useEffect, forwardRef, useRef } from 'react';
import PropTypes from 'prop-types';

import {
  Box,
  Card,
  CardActions,
  CardContent,
  CardMedia,
  Divider,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  Grid,
  Typography,
  TextField,
  Button,
  Menu,
  MenuItem,
  ListItemIcon,
  Modal,
  InputLabel,
  IconButton,
  Tabs,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Snackbar,
  Select,
  Stack,
  Pagination,
  Paper
} from "@mui/material";
import MuiAlert from '@mui/material/Alert';
import styledComponent from "styled-components";
import { CopyToClipboard } from "react-copy-to-clipboard";

import axios from  "axios";
import { Formik } from 'formik';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { Rowing } from '@material-ui/icons';

import imgNotFound from '../assets/icons/no-image.png'

const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { xs: '80%', md: 400 },
    maxHeight: '66vh',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    overflow: 'scroll'
};

const Alert = forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const Container = styledComponent.div`
    padding: 20px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
`;

const Product = ({productData}) => {
    const textAreaRef = useRef(null);
    // const copyToClipboard = (e) => {
    //   console.log(textAreaRef.current.textContent);
    //   document.execCommand('copy', false, textAreaRef.current.textContent);
    // };
    return (
        <div style={{ minHeight: '80vh', padding: '0px 18px 50px 18px'}}>
            {/* {JSON.stringify(productData)} */}
            <Grid container justify="center">
              <Grid item xs={12} align="center">
                <Typography variant="h5" fontWeight="700">
                  {productData?.namaproduk}
                </Typography>
              </Grid>
              <Grid item xs={12} align="center">
                <Typography variant="h5">
                  Rp. {productData?.harga.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}
                </Typography>
              </Grid>
              <Grid item xs={12} align="center">
                <Box
                  sx={{
                    width: { xs: 300, sm: 360, md: 640 },
                    '&:hover': {
                      opacity: [0.9, 0.8, 0.7]
                    },
                  }}
                >
                  <img
                    src={`https://wnj.web.id/adminwnj/foto/`+productData?.foto}
                    width="100%"
                    onError={({ currentTarget }) => {
                      currentTarget.onerror = null; // prevents looping
                      currentTarget.src= imgNotFound;
                    }}
                  />
                </Box>
              </Grid>
              <Grid item xs={12} paddingY={2}>
                <Grid container>
                    <Grid item xs={6} align="center">
                      <Button size="small" variant="contained" sx={{ height: '50px' }}>Lihat Foto lengkap</Button>
                    </Grid>
                    <Grid item xs={6} align="center">
                      <CopyToClipboard text={productData?.deskripsi}
                        onCopy={() => console.log('copied')}
                      >
                        <Button size="small" variant="contained" sx={{ height: '50px' }}>
                          Copy Deskripsi
                        </Button>
                      </CopyToClipboard>
                    </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} align="left">
                <Box
                  sx={{ padding: 3 }}
                >
                  <Typography variant="subtitle2" ref={textAreaRef}>
                    {productData?.deskripsi}
                  </Typography>
                </Box>
              </Grid>
            </Grid>
        </div>
    )
}

export default Product
